import script from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', _vm._b({
    staticClass: "v-chip",
    class: _vm.classes,
    style: _vm.styles,
    on: {
      "click": _vm.handleClick,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.handleClick.apply(null, arguments);
      }
    }
  }, 'span', _vm.attributes, false), [_c('span', {
    staticClass: "v-chip__content"
  }, [_vm._t("default"), _vm._v(" "), _vm.close ? _c('button', {
    staticClass: "v-chip__close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('click:close');
      }
    }
  }, [_c('CloseIcon', {
    staticClass: "v-chip__close__icon"
  })], 1) : _vm._e()], 2)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-098b4bd0_0", {
    source: ".v-chip[data-v-098b4bd0]{background:var(--c-color);color:var(--c-text-color);align-items:center;border-radius:1rem;cursor:default;display:inline-flex;line-height:1.25em;font-size:var(--c-font-size);font-family:var(--g-font-body-family);font-weight:400;flex-shrink:0;max-width:100%;overflow:hidden;padding:.55em 1.1em;position:relative;text-decoration:none;transition-duration:.28s;transition-property:box-shadow,opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);vertical-align:middle;white-space:nowrap}.v-chip--label[data-v-098b4bd0]{border-radius:var(--g-border-radius-standard)}.v-chip--selectable[data-v-098b4bd0]{cursor:pointer;user-select:none}.v-chip--selectable[data-v-098b4bd0]:focus,.v-chip--selectable[data-v-098b4bd0]:hover{background:var(--c-color-active)}.v-chip--selectable[data-v-098b4bd0]:active{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.v-chip--selected[data-v-098b4bd0]{background:var(--c-color-selected);color:var(--c-color-selected-text)}.v-chip--selected[data-v-098b4bd0]:focus,.v-chip--selected[data-v-098b4bd0]:hover{background:var(--c-color-selected-active)}.v-chip--crossed[data-v-098b4bd0]{text-decoration:line-through}.v-chip--disabled[data-v-098b4bd0]{opacity:.4;pointer-events:none;user-select:none}.v-chip__content[data-v-098b4bd0]{align-items:center;display:inline-flex;height:100%;max-width:100%}.v-chip__close[data-v-098b4bd0]{align-items:center;background:0 0;color:var(--c-text-color);border:none;cursor:pointer;display:inline-flex;font-size:1.25em;margin-left:.4em;margin-right:-.4em;padding:0;position:relative;justify-content:center}.v-chip__close[data-v-098b4bd0]:before{content:\"\";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);height:250%;width:200%}.v-chip__close__icon[data-v-098b4bd0]{height:.85em;width:.85em}.v-chip__close[data-v-098b4bd0]:focus,.v-chip__close[data-v-098b4bd0]:hover{opacity:.75}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-098b4bd0";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Chip = __vue_component__;
export { Chip as default };